import React from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';

// Styled toggle button with different colors based on state
const ToggleButton = styled(Button)(({ theme, isAnd }) => ({
  borderRadius: '6px',
  fontWeight: 'bold',
  border: isAnd ? '2px solid #a3a1ca)' : '2px solid #458f80',
  backgroundColor: isAnd ? '#bebcd6' : '#add3cb', // Blue for AND, Red for OR
  color: 'black',
  '&:hover': {
    backgroundColor: isAnd ? '#8e8cc4' : '#43a08c', // Darker shade on hover
  },
  transition: 'background-color 0.3s ease',
}));

// Replace your DropdownCust component with this ToggleButton component
const AndOrToggle = ({ value, onChange, index, defaultValue = "1" }) => {
  // Assuming "1" is AND and "2" is OR based on your display_order pattern
  const isAnd = value === "1";

  const handleToggle = () => {
    // Toggle between "1" (AND) and "2" (OR)
    const newValue = isAnd ? "2" : "1";
    onChange({
      target: {
        value: newValue
      }
    });
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Tooltip placement="right" title={isAnd ? "Click to change to OR" : "Click to change to AND"} arrow>
        <ToggleButton
          variant="contained"
          isAnd={isAnd}
          onClick={handleToggle}
        >
          {isAnd ? 'AND' : 'OR'}
        </ToggleButton>
      </Tooltip>
    </Box>
  );
};

export default AndOrToggle;
